module.exports = __webpack_public_path__ + "img/board.5b22aafc.png";